import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  icon: {
    color: "#B2BBE3",
    height: 120,
    width: 120,
  },
}));
